import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UILink from 'UIComponents/link/UILink';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { findValidI18nKey } from 'pricing-pages-lib/utils/languageUtils';
import { SCREENS } from 'pricing-pages-ui/constants/tracking/Locations';
import Raven from 'raven-js';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { DEFAULT, OWNERSHIP_CHECK_FAILED } from '../../constants/ErrorCauses';
import { Metrics } from '../../utils/metrics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ErrorPage({
  errorCause = DEFAULT,
  additionalErrorLogging = {}
}) {
  useEffect(() => {
    console.error(`ErrorPage visited with error cause: ${errorCause}`);
    getUsageTracker().track('pageView', {
      screen: SCREENS.ERROR
    });
    Metrics.counter('error-page-visited', {
      errorType: errorCause
    }).increment();
    Raven.captureMessage(`ErrorPage visited with error cause: ${errorCause}`, {
      extra: additionalErrorLogging
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const titleKey = findValidI18nKey([`pricingPage.pages.errorPage.${errorCause}.title`, `pricingPage.pages.errorPage.default.title`]);
  const paragraphKey = findValidI18nKey([`pricingPage.pages.errorPage.${errorCause}.paragraph_jsx`, `pricingPage.pages.errorPage.default.paragraph_jsx`]);
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-column align-center p-all-10",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "ERROR_PAGE"
    }), /*#__PURE__*/_jsx(UIIllustration, {
      className: "m-y-10",
      name: "errors/general",
      height: 200
    }), /*#__PURE__*/_jsx("h4", {
      className: "m-top-6",
      children: titleKey && /*#__PURE__*/_jsx(FormattedMessage, {
        message: titleKey
      })
    }), /*#__PURE__*/_jsx("p", {
      className: "m-bottom-10",
      children: paragraphKey && /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: paragraphKey,
        elements: {
          UILink
        },
        options: {
          onClick: () => {
            if (errorCause === OWNERSHIP_CHECK_FAILED) {
              getUsageTracker().track('externalLinkClick', {
                name: 'contact-support-page'
              });
            }
          }
        }
      })
    })]
  });
}
export default ErrorPage;